import React, { Component } from "react";
import { connect } from "react-redux";
import { goBack } from "react-router-redux";
import { breadcrumbs } from "../../../../actions/appActions";
import loginInfo from "../../components/LoginInfo";
import AuditHistoryView from "../../components/AuditHistoryView";
import OfficialHistoryDetailGrid from "../../components/grids/OfficialHistoryDetailGrid";
import { FINANCIAL_HISTORY_ENTITIES, FINANCIAL_HISTORY_ACTIONS } from "../../components/audit/entityLabels";
import Button from "../../../../components/form/Button";
import { styles } from "../../index";

class FinancialInstitutionHistoryPage extends Component {
  componentWillMount() {
    const { auth } = this.props;
    this.props.breadcrumbs([
      { label: "Finanční instituce", path: `${auth.startUrl}/financni-instituce` },
      { label: "Historie" },
    ]);
  }

  render() {
    const { auth, params } = this.props;
    return (
      <div>
        <AuditHistoryView
          auth={auth}
          grid={OfficialHistoryDetailGrid}
          gridName="financialInstitutionHistoryGridV2"
          url={`${auth.startUrl}/api/financni-instituce/${params.id}/historie-aktivit`}
          allowedEntityTypes={FINANCIAL_HISTORY_ENTITIES}
          allowedActions={FINANCIAL_HISTORY_ACTIONS}
        />
        <div style={{ marginTop: 12 }}>
          <Button
            type="button"
            style={styles.buttons}
            label="Zpět"
            onClick={() => this.props.goBack()}
          />
        </div>
      </div>
    );
  }
}

export default connect(null, { breadcrumbs, goBack })(loginInfo(FinancialInstitutionHistoryPage));
